import { Spin } from 'antd'

const LoadingSpinner = () => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#ffffff'
    }}>
      <Spin size="large" />
    </div>
  )
}

export default LoadingSpinner 